import React from 'react';
import Button from './Button';
import Icon from './Icon';
import { truncatePreservingNewlines } from '../utils/textHelpers';

/**
 * MemoryNoteCard
 * Variants:
 *  - default: date (small gray), body (16), author row (12 gray)
 *  - cta: replaces date with a pill button "See all memory notes"
 *  - grid: compact 1/2 width style, padding 16, body 14, date #ADADAD
 */
export default function MemoryNoteCard({
  variant = 'default', // 'default' | 'cta' | 'grid'
  date = '02.10.25',
  body = 'Dette er et rigtig godt minde...',
  author = 'Elias Christensen',
  onCtaClick,
  className = '',
  maxWords,
  headerEnd,
  children
}) {
  const isGrid = variant === 'grid';
  const containerStyle = {
    background: '#FFFFFF',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.10)',
    borderRadius: 20,
    padding: isGrid ? 16 : 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: isGrid ? 16 : 24,
    width: '100%'
  };

  const dateColor = isGrid ? '#ADADAD' : '#B9B9B9';
  const bodySize = isGrid ? 14 : 16;

  const previewBody = truncatePreservingNewlines(body, maxWords);
  const paragraphs = String(previewBody || '').split(/\n+/);

  return (
    <div className={className} style={containerStyle}>
      {variant === 'cta' ? (
        <Button trailingIconName="arrowRight" onClick={onCtaClick}>See all memory notes</Button>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div style={{ borderRadius: 100, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 4, height: 4, borderRadius: '50%', backgroundColor: '#E09053' }}></span>
          <span style={{ color: dateColor, fontSize: 12, fontFamily: 'Poppins', fontWeight: 400 }}>{date}</span>
          </div>
          {headerEnd}
        </div>
      )}

      <div style={{ alignSelf: 'stretch' }}>
        {paragraphs.length > 0 ? (
          paragraphs.map((paragraph, idx) => (
            <p
              key={idx}
              style={{
                color: '#000000',
                fontSize: bodySize,
                fontFamily: 'Poppins',
                fontWeight: 400,
                lineHeight: 1.6,
                marginBottom: idx === paragraphs.length - 1 ? 0 : (isGrid ? 10 : 14),
              }}
            >
              {paragraph}
            </p>
          ))
        ) : (
          <p
            style={{
              color: '#000000',
              fontSize: bodySize,
              fontFamily: 'Poppins',
              fontWeight: 400,
              lineHeight: 1.6,
            }}
          >
            {previewBody}
          </p>
        )}
      </div>

      <div className="inline-flex items-center gap-2" style={{
        padding: '6px 12px',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        borderRadius: 100,
      }}>
        <Icon name="author" size={12} color="#939393" />
        <span style={{ color: '#939393', fontSize: 12, fontFamily: 'Poppins', fontWeight: 500 }}>{author}</span>
      </div>

      {children}
    </div>
  );
}


